import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Modal pequeno e centralizado — pra ações rápidas de 2 cliques (§8/§17 da
// evolução de produto: registrar pagamento/vincular projeto sem abrir o
// drawer completo). Diferente de `Sheet` (painel lateral, pra detalhe
// completo de uma entidade).
export function Dialog({ open, onClose, title, footer, children, width = 380 }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="crm-overlay crm-dialog-overlay" onClick={onClose}>
      <div className="crm-dialog" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        <div className="crm-modal-header">
          <h3 className="crm-modal-title">{title}</h3>
          <button className="crm-icon-btn" onClick={onClose} aria-label="Fechar"><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <div className="crm-modal-body">{children}</div>
        {footer && <div className="crm-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default Dialog;
